import { Box } from "prism-react";
import React from "react";

export const VersionList: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <Box
      as="ul"
      css={{
        margin: 0,
        padding: 0,

        "> *": {
          marginBottom: "$3",
        },

        "> :last-child": {
          marginBottom: "$0",
        },
      }}
    >
      {children}
    </Box>
  );
};
